<script setup lang="ts">
import { openCustomerService } from '@/utils/customerService'
import CsSvg from '@/svg/CS.svg?component'

/**
 * 客服按钮组件
 * 点击打开客服窗口
 * 默认显示 CS.svg 图标，但可以通过 slot 自定义内容
 */

const handleClick = () => {
  openCustomerService()
}
</script>

<template>
  <button
    class="cs-button inline-flex items-center justify-center p-0 border-none cursor-pointer bg-transparent"
    type="button"
    @click="handleClick"
    aria-label="打开客服"
  >
    <slot>
      <CsSvg class="cs-icon w-full h-full" />
    </slot>
  </button>
</template>

<style scoped></style>
